import {defineStore} from 'pinia'
import api from '@/services/api'

export const useAccessGroupsStore = defineStore('accessGroups', {
    state: () => ({
        items: [],
    }),
    actions: {
        async init() {
            const res = await api.get('api/component/m_registrants_groups', {
                params: {
                    accessGroup: 1,
                    isArchived: 0
                }
            })
            
            this.items = res.data.items
        }
    }
})